import * as React from 'react';
import styles from './sidebar.module.css';
import { convertStringtoDollarString } from '../../../helpers/formathelper';

export const AnalysisSideBarComponent: React.FC<any> = (props) => {
	const { currentAnnualContribution, currentAge, goalType, inflationRate, 
		investmentAmount, lifeExpectancy, targetAmount, targetAnnualIncome, targetRetirementAge } = props.goalAccountDetails;

	let goalsMainTitle;
	switch (goalType) {
		case 'Retirement':
			goalsMainTitle = 'Your Retirement Goal';
			break;
		case 'GeneralSavings':
			goalsMainTitle = 'Your General Investing Goal';
			break;
		case 'Unknown':
			goalsMainTitle = 'Your Financial Goal';
			break;		
	}

	return (
		<div className={styles.leftPane}>
			<h3 className={styles.title}>
				{ goalsMainTitle }
			</h3>
			{(goalType == 'Retirement') && <div className={styles.analysisDetails}>
				<div className={styles.goalDetails}>
					<p className={styles.text}>Investment Amount</p>
					<p className={styles.value}>{convertStringtoDollarString(investmentAmount)}</p>
				</div>
				
				<div className={styles.goalDetails}>
					<p className={styles.text}>Current Age</p>
					<p className={styles.value}>{currentAge} Years</p>
				</div>
				<div className={styles.goalDetails}>
					<p className={styles.text}>Retirement Age</p>
					<p className={styles.value}>{targetRetirementAge} Years</p>
				</div>
				<div className={styles.goalDetails}>
					<p className={styles.text}>Current Annual Savings</p>
					<p className={styles.value}>{currentAnnualContribution > 0 ? convertStringtoDollarString(currentAnnualContribution) : '$0'}</p>
				</div>
				<div className={styles.goalDetails}>
					<p className={styles.text}>Target Annual Post-Retirement Income</p>
					<p className={styles.value}>{targetAnnualIncome > 0 ? convertStringtoDollarString(targetAnnualIncome) : 0}</p>
				</div>
				<div className={styles.goalDetails}>
					<p className={styles.text}>Life Expectancy</p>
					<p className={styles.value}>90 Years</p>
				</div>
				<div className={styles.goalDetails}>
					<p className={styles.text}>Inflation Rate</p>
					<p className={styles.value}>2%</p>
				</div>
				<div className={styles.goalDetails}>
					<p className={styles.text}>Target Amount at Retirement</p>
					<p className={styles.value}>{targetAmount > 0 ? convertStringtoDollarString(targetAmount) : 0}</p>
				</div>
			</div>}

			{(goalType === 'GeneralSavings') && <div className={styles.analysisDetails}>
				<div className={styles.goalDetails}>
					<p className={styles.text}>Investment Amount</p>
					<p className={styles.value}>{convertStringtoDollarString(investmentAmount)}</p>
				</div>
				<div className={styles.goalDetails}>
					<p className={styles.text}>Current Annual Savings</p>
					<p className={styles.value}>{currentAnnualContribution > 0 ? convertStringtoDollarString(currentAnnualContribution) : '$0'}</p>
				</div>
				<div className={styles.goalDetails}>
					<p className={styles.text}>Current Age</p>
					<p className={styles.value}>{currentAge} Years</p>
				</div>
				<div className={styles.goalDetails}>
					<p className={styles.text}>Target Amount</p>
					<p className={styles.value}>{targetAmount > 0 ? convertStringtoDollarString(targetAmount) : 0}</p>
				</div>
			</div>}

			{(goalType === 'Unknown') && <div className={styles.analysisDetails}>
				<div className={styles.goalDetails}>
					<p className={styles.text}>Investment Goal</p>
					<p className={styles.value}>No Goal</p>
				</div>
			</div>}
			
		</div>
	);
};
